import React, { useState } from "react";
import moment from "moment";
import _ from "lodash";
import cx from "classnames";
import XLSX from "xlsx";
import { FileDownloadOutlined } from "@mui/icons-material";
import { Fields } from "./shared/Fields";

const DownloadReceipt = ({
  submissionType,
  submissionName,
  attachments,
  className,
  label = (
    <>
      <FileDownloadOutlined style={{ fontSize: "18px", verticalAlign: "text-bottom" }} /> Download
      Receipt
    </>
  ),
}) => {
  const FILENAME_PREFIXES = {
    pharmacy: "340B_ESP_Pharmacy",
    medical: "340B_ESP_Medical",
    pharmacy_encounter: "340B_ESP_Pharmacy_Encounter",
    medical_encounter: "340B_ESP_Medical_Encounter",
  };
  const filenamePrefix = FILENAME_PREFIXES[submissionType] || "340B_ESP";
  const [downloading, setDownloading] = useState(false);

  const buildWorkbook = () => {
    const workbook = XLSX.utils.book_new();
    const headers = ["esp_id", ..._.keys(Fields[submissionType])];
    const sheet = XLSX.utils.aoa_to_sheet([headers]);

    _.forEach(attachments, (file, index) => {
      XLSX.utils.sheet_add_json(sheet, file.submittableRowsWithEspId, {
        header: headers,
        skipHeader: true,
        blankrows: false,
        origin: index === 0 ? "A2" : -1,
      });
    });

    XLSX.utils.book_append_sheet(workbook, sheet, "340B ESP™");
    return workbook;
  };

  const handleDownload = () => {
    setDownloading(true);

    const workbook = buildWorkbook();
    const fallbackName = `${filenamePrefix}_${moment().format("YYYY-MM-DD_HH-mm-ss")}`;
    const filename = (submissionName || fallbackName).trim().replace(/\s+/g, "_");
    XLSX.writeFile(workbook, `${filename}_submission_data.csv`);

    setDownloading(false);
  };

  const hasSubmittableRows = attachments.some((file) => file.submittableRowsWithEspId.length > 0);

  return (
    <button
      className={cx(
        { "btn btn--outline btn--white": !className },
        { "btn--disabled": !hasSubmittableRows },
        className
      )}
      disabled={!hasSubmittableRows}
      onClick={hasSubmittableRows ? handleDownload : undefined}
    >
      {downloading && <div className="loading-indicator"></div>}
      {label}
    </button>
  );
};

export default DownloadReceipt;
